<template>
  <div class="contact-container">
    <div class="contact-content">
      <h1>Contact Us</h1>
      
      <div class="contact-grid">
        <!-- Map Section -->
        <div class="contact-info">
          <div class="map-container">
            <iframe
              width="100%"
              height="450"
              style="border:0"
              loading="lazy"
              allowfullscreen
              referrerpolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBSiRCj51LVKF5F-oSW3GqJbrCWtadz-pk&q=Kiddokove+Kids+Club+Macquarie+Park,Shop+1007A+Macquarie+Centre+NSW">
            </iframe>
          </div>
        </div>

        <!-- Contact Form -->
        <div class="contact-form">
          <h3>Leave a message</h3>
          <form @submit.prevent="submitForm">
            <div class="form-group">
              <label for="name">Name</label>
              <input type="text" id="name" v-model="form.name" required>
            </div>

            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" id="email" v-model="form.email" required>
            </div>
            
            <div class="form-group">
              <label for="message">Message</label>
              <textarea id="message" v-model="form.message" rows="4" required></textarea>
            </div>
            
            <button type="submit" class="submit-btn">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactView',
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      }
    }
  },
  methods: {
    async submitForm() {
      try {
        const response = await fetch('/api/admin/contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: this.form.name,
            email: this.form.email,
            message: this.form.message
          })
        });

        if (!response.ok) {
          throw new Error('Failed to send message');
        }

        // 成功提示
        alert('Thank you for your message! We will get back to you soon.');
        
        // 重置表单
        this.form = {
          name: '',
          email: '',
          message: ''
        };
      } catch (error) {
        console.error('Error sending message:', error);
        alert('Failed to send message. Please try again later.');
      }
    }
  }
}
</script>

<style scoped>
.contact-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  padding-top: 120px;
}

.contact-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

h1 {
  text-align: center;
  color: rgb(89, 89, 89);
  margin-bottom: 2rem;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
}

.map-container {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.map-container iframe {
  display: block;
  width: 100%;
}

/* Contact Form Styles */
.contact-form {
  background-color: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.contact-form h3 {
  color: rgb(89, 89, 89);
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: rgb(89, 89, 89);
}

input, textarea {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s;
  color: rgb(89, 89, 89);
}

input:focus, textarea:focus {
  outline: none;
  border-color: rgb(254, 247, 245);
}

.submit-btn {
  background-color: rgb(254, 247, 245);
  color: rgb(89, 89, 89);
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s;
  width: 100%;
}

.submit-btn:hover {
  background-color: rgb(252, 237, 233);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .contact-container {
    padding: 1rem;
  }

  .contact-grid {
    grid-template-columns: 1fr;
  }

  .map-container {
    height: 300px;
  }
}
</style> 